import createVueApp from '@/common/create_app'

Styxie.Initializers.AdminMlapPlaybooks = {
  index: async(props) => {
    const { default: IndexPage } = await import('@/vue_widgets/admin/mlap_playbooks/index.vue')
    createVueApp(IndexPage, { props })
  },
  new: async(props) => {
    const { default: FormPage } = await import('@/vue_widgets/admin/mlap_playbooks/form.vue')
    createVueApp(FormPage, { props })
  },
  edit: async(props) => {
    const { default: FormPage } = await import('@/vue_widgets/admin/mlap_playbooks/form.vue')
    createVueApp(FormPage, { props })
  }
}
